import type {
  HeroMediaData,
  PreviewImagesData,
} from "@/components/collection/overview/types"
import type { OverviewModules } from "./page-editor-store"
import type { MessageData, SectionType } from "./types"

function postMessage(data: MessageData) {
  if (typeof window !== "undefined" && window.parent) {
    window.parent.postMessage(data, window.location.origin)
  }
}

export function openSidebar() {
  postMessage({
    sidebar: {
      isOpen: true,
    },
  })
}

export function syncModulesToParent(modules: OverviewModules) {
  postMessage({
    syncModules: modules,
  })
}

export function syncPreviewImagesToParent(previewImages: PreviewImagesData) {
  postMessage({
    syncPreviewImages: previewImages,
  })
}

export function syncHeroMediaToParent(heroMedia: HeroMediaData) {
  postMessage({
    syncHeroMedia: heroMedia,
  })
}

export function syncLogoToParent(logoData: {
  logoMedia: string | null
  logoToken: string | null
}) {
  postMessage({
    syncLogo: logoData,
  })
}

// biome-ignore lint/suspicious/noExplicitAny: TODO FIX
export function getModuleType(module: any): SectionType | null {
  if (!module?.__typename) {
    return null
  }

  switch (module.__typename) {
    case "CollectionNarrativeModule":
      return module.variant || "TEXT"
    case "CollectionFAQModule":
      return "FAQ"
    case "CollectionTeamModule":
      return "TEAM"
    case "CollectionContentBlockModule":
      return module.variant || "FREEFORM"
    default:
      return null
  }
}

export function openEditSidebar(moduleIndex: number, moduleType: SectionType) {
  postMessage({
    sidebar: {
      isOpen: true,
      action: {
        type: moduleType,
        index: moduleIndex,
        operation: "edit",
      },
    },
  })
}

export function openLinksSidebar() {
  postMessage({
    sidebar: {
      isOpen: true,
      action: {
        type: "BANNER_LINKS",
        index: null,
        operation: "edit",
      },
    },
  })
}

export function openBannerSidebar() {
  postMessage({
    sidebar: {
      isOpen: true,
      action: {
        type: "BANNER_MEDIA",
        index: null,
        operation: "edit",
      },
    },
  })
}
